import {Grid2} from "@mui/material";
import {useAuth} from "@/app/auth/AuthContext";
import {getCurrentDate} from "@/lib/date-utils";

export const StatusFooter = () => {
    const { clientVersion, environment } = useAuth();
    const testHint =
        environment !== "prod"
            ? {
                  backgroundColor: "orange",
                  px: 1,
                  // mx: -1,
                  borderRadius: 1
              }
            : {};
    return (
        <Grid2
            container
            direction="row"
            alignItems="center"
            padding="2px 0 0 0"
            justifyContent="space-between"
            sx={{ fontSize: "80%", ...testHint }}
        >
            <Grid2>BoxHub V{clientVersion}</Grid2>
            <Grid2>{environment && environment !== "prod" ? `TEST SYSTEM: ${environment}` : ""}</Grid2>
            <Grid2>Copyright © {getCurrentDate().getFullYear()} JHH</Grid2>
        </Grid2>
    );
};
